import { Switch, Route, Redirect, BrowserRouter, Routes, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/auth/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import BillPay from "./pages/BillPay";
import Electricity from "./pages/Electricity";
import DTH from "./pages/DTH";
import Fastag from "./pages/Fastag";
import Landline from "./pages/Landline";
import LifeInsurance from "./pages/LifeInsurance";
import Loan from "./pages/Loan";
import LPG from "./pages/LPG";
import MobilePostpaid from "./pages/MobilePostpaid";
import PipedGas from "./pages/PipedGas";
import Water from "./pages/Water";
import BillDetails from "./pages/BillDetails";
import ComingSoon from "./pages/ComingSoon";
import UserDetailsForm from "./pages/UserDetails";
import VideoUploadPage from "./pages/UploadVideo";
import UploadSuccess from "./pages/UploadSuccess";
import Receipt from "./pages/Reciept";
import Recharge from "./pages/Recharge";
import RechargePlans from "./pages/RechargePlans";
import GetQR from "./pages/GetQR";
import FetchQR from "./pages/FetchQR";
import Members from "./pages/Members";
import AddVehicle from "./pages/AddVehicle";
import MemberVehicle from "./pages/MemberVehicle";
import DTHdetails from "./pages/DTHdetails";
import Transaction from "./pages/Transaction";
import AddMoney from "./pages/AddMoney";
import Insurance from "./pages/Insurance";
import LandingPage from "./pages/LandingPage";
import ListService from "./pages/ListService";
import ForgotPassword from "./pages/ForgotPassword";
import CheckChallan from "./pages/CheckChallan";
import ListBusiness from "./pages/ListBusiness";
import BusinessDashboard from "./pages/BusinessDashboard";
import BusinessDetails from "./pages/BusinessDetails";
import PUCCheck from "./pages/PUCCheck";
import ApplyCreditCard from "./pages/ApplyCreditCard";
import Page from "./pages/Page";
import AddMember from "./pages/AddMember";
import Mahakumbh from "./pages/Mahakumbh";
import AddStudent from "./pages/AddStudent";
import ViewStudents from "./pages/ViewStudents";
import AttendanceView from "./pages/AttendanceView";
import JoinMlm from "./pages/JoinMlm";
import Member from "./pages/Member";
import AttendanceCalendar from "./pages/AttendanceCalendar";
import InsuranceHistory from "./pages/InsuranceHistory";
import ContactUs from "./pages/ContactUs";
import VehicleScan from "./pages/VehicleScan";
import EditMember from "./pages/EditMember";
import MlmIncome from "./pages/MlmIncome";
import MlmTreeView from "./pages/MlmTreeView";
import SwitchToPaid from "./pages/SwitchToPaid";
import BusBooking from "./pages/BusBooking";
import AvailableTrip from './pages/AvailableTrip';
import AttendanceScan from "./pages/AttendanceScan";
import YourUpline from "./pages/YourUpline";
import Withdraw from "./pages/Withdraw";
import WithdrawalHistory from "./pages/WithdrawalHistory";
import Security from "./pages/Security";
import Support from "./pages/Support";

const App = () => {
  const user = localStorage.getItem("user");
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const RouteMiddleware = ({ element, comingSoon }) => {
    if (!user) {
      if (page === "") {
        return <LandingPage />
      } else {
        return <Navigate to="/sign-in" replace />
      }
    }

    if (comingSoon) {
      // Redirect or show a custom message if `comingSoon` is true
      return <Navigate to="/coming-soon" replace />;
    }
    // Render the actual component if `comingSoon` is false
    return element;
  };

  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/list-services" element={<ListService />} />
        <Route path="/business-details/:business" element={<BusinessDetails />} />
        <Route path="/scan/:qr_no" element={<VehicleScan />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/*" element={<Page />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="contact-us" element={<ContactUs />} />

        {/* Main Routes */}
        <Route path="/user/" element={<RouteMiddleware element={<Main />} comingSoon={false} />}>
          <Route path="home" element={<RouteMiddleware element={<Home />} comingSoon={false} />} />
          <Route path="tables" element={<RouteMiddleware element={<Tables />} comingSoon={true} />} />
          <Route path="billing" element={<RouteMiddleware element={<Billing />} comingSoon={true} />} />
          <Route path="rtl" element={<RouteMiddleware element={<Rtl />} comingSoon={true} />} />
          <Route path="parent/add-student" element={<RouteMiddleware element={<AddStudent />} comingSoon={false} />} />
          <Route path="parent/students" element={<RouteMiddleware element={<ViewStudents />} comingSoon={false} />} />
          <Route path="profile" element={<RouteMiddleware element={<UserDetailsForm />} comingSoon={false} />} />
          <Route path="bill-details" element={<RouteMiddleware element={<BillDetails />} comingSoon={false} />} />
          <Route path="dth-details" element={<RouteMiddleware element={<DTHdetails />} comingSoon={false} />} />
          <Route path="upload-video" element={<RouteMiddleware element={<VideoUploadPage />} comingSoon={false} />} />
          <Route path="upload-success" element={<RouteMiddleware element={<UploadSuccess />} comingSoon={false} />} />
          <Route path="reciept/:txnId" element={<RouteMiddleware element={<Receipt />} comingSoon={false} />} />
          <Route path="add-user/:type" element={<RouteMiddleware element={<AddMember />} comingSoon={false} />} />
          <Route path="attendance" element={<RouteMiddleware element={<AttendanceView />} comingSoon={false} />} />
          <Route path="affiliate-program/:user" element={<RouteMiddleware element={<JoinMlm />} comingSoon={false} />} />
          <Route path="affiliate-program" element={<RouteMiddleware element={<JoinMlm />} comingSoon={false} />} />
          <Route path="affiliate-income/:type" element={<RouteMiddleware element={<MlmIncome />} comingSoon={false} />} />
          <Route path="switch-to-paid" element={<RouteMiddleware element={<SwitchToPaid />} comingSoon={false} />} />
          <Route path="mahakumbh" element={<RouteMiddleware element={<Mahakumbh />} comingSoon={false} />} />
          <Route path="recharge" element={<RouteMiddleware element={<Recharge />} comingSoon={false} />} />
          <Route path="recharge/plans" element={<RouteMiddleware element={<RechargePlans />} comingSoon={false} />} />
          <Route path="bus-booking" element={<RouteMiddleware element={<BusBooking />} comingSoon={true} />} />
          <Route path="available-trip" element={<RouteMiddleware element={<AvailableTrip />} comingSoon={true} />} />
          <Route path="attendance-scan" element={<RouteMiddleware element={<AttendanceScan />} comingSoon={false} />} />
          <Route path="your-upline" element={<RouteMiddleware element={<YourUpline />} comingSoon={false} />} />
          <Route path="withdraw" element={<RouteMiddleware element={<Withdraw />} comingSoon={false} />} />
          <Route path="withdrawal-history" element={<RouteMiddleware element={<WithdrawalHistory />} comingSoon={false} />} />
          <Route path="security" element={<RouteMiddleware element={<Security />} comingSoon={false} />} />
          <Route path="support" element={<RouteMiddleware element={<Support />} comingSoon={false} />} />

          <Route path="parking" element={<RouteMiddleware element={<Recharge />} comingSoon={true} />} />
          <Route path="buy-gps" element={<RouteMiddleware element={<Recharge />} comingSoon={true} />} />
          <Route path="get-qr" element={<RouteMiddleware element={<GetQR />} comingSoon={false} />} />
          <Route path="fetch-qr" element={<RouteMiddleware element={<FetchQR />} comingSoon={false} />} />
          <Route path="puc-check" element={<RouteMiddleware element={<PUCCheck />} comingSoon={false} />} />
          <Route path="check-challan" element={<RouteMiddleware element={<CheckChallan />} comingSoon={false} />} />
          <Route path="members" element={<RouteMiddleware element={<Members />} comingSoon={false} />} />
          <Route path="edit-member/:type/:id" element={<RouteMiddleware element={<EditMember />} comingSoon={false} />} />
          <Route path="attendance-calendar" element={<RouteMiddleware element={<AttendanceCalendar />} comingSoon={false} />} />
          <Route path="get-id-card" element={<RouteMiddleware element={<Member />} comingSoon={false} />} />
          <Route path="add-vehicle" element={<RouteMiddleware element={<AddVehicle />} comingSoon={false} />} />
          <Route path="members/vehicles" element={<RouteMiddleware element={<MemberVehicle />} comingSoon={false} />} />
          <Route path="transactions" element={<RouteMiddleware element={<Transaction />} comingSoon={false} />} />
          <Route path="add-money" element={<RouteMiddleware element={<AddMoney />} comingSoon={false} />} />
          <Route path="insurance" element={<RouteMiddleware element={<Insurance />} comingSoon={false} />} />
          <Route path="list-business" element={<RouteMiddleware element={<ListBusiness />} comingSoon={false} />} />
          <Route path="business-dashboard" element={<RouteMiddleware element={<BusinessDashboard />} comingSoon={false} />} />
          <Route path="apply-credit-card" element={<RouteMiddleware element={<ApplyCreditCard />} comingSoon={false} />} />
          <Route path="insurance-history" element={<RouteMiddleware element={<InsuranceHistory />} comingSoon={false} />} />
          <Route path="affiliate-tree/:userId" element={<RouteMiddleware element={<MlmTreeView />} comingSoon={false} />} />
          <Route path="affiliate-tree" element={<RouteMiddleware element={<MlmTreeView />} comingSoon={false} />} />

          {/* Nested Routes for Bill Pay */}
          <Route path="bill-pay" element={<RouteMiddleware element={<BillPay />} comingSoon={false} />}>
            <Route path="electricity" element={<RouteMiddleware element={<Electricity />} comingSoon={false} />} />
            <Route path="dth" element={<RouteMiddleware element={<DTH />} comingSoon={false} />} />
            <Route path="fastag" element={<RouteMiddleware element={<Fastag />} comingSoon={false} />} />
            <Route path="landline-postpaid" element={<RouteMiddleware element={<Landline />} comingSoon={false} />} />
            <Route path="life-insurance" element={<RouteMiddleware element={<LifeInsurance />} comingSoon={false} />} />
            <Route path="loan" element={<RouteMiddleware element={<Loan />} comingSoon={false} />} />
            <Route path="lpg-gas" element={<RouteMiddleware element={<LPG />} comingSoon={false} />} />
            <Route path="mobile-postpaid" element={<RouteMiddleware element={<MobilePostpaid />} comingSoon={false} />} />
            <Route path="piped-gas" element={<RouteMiddleware element={<PipedGas />} comingSoon={false} />} />
            <Route path="water" element={<RouteMiddleware element={<Water />} comingSoon={false} />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default App;
